/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */
import { ChangeEvent, FC, memo, MouseEvent } from 'react';

import { RESULT } from '@/commons/data';
import { cn } from '@/utils';

interface ProgressProps {
    videoDuration: number;
    bufferProgress: number;
    currentProgress: number;
    seekProgress: number;
    seekTooltipPosition: string;
    seekTooltip: string;
    chapters: { time: number; result: RESULT }[];
    onHover: (event: MouseEvent) => void;
    onSeek: (event: ChangeEvent<HTMLInputElement>) => void;
}

const Progress: FC<ProgressProps> = ({
    bufferProgress,
    currentProgress,
    videoDuration,
    seekProgress,
    seekTooltipPosition,
    seekTooltip,
    chapters = [],
    onHover,
    onSeek,
}) => {
    return (
        <div className="vp-progress">
            <div className="vp-progress__range">
                <div className="vp-progress__range--background" />
                <div className="vp-progress__range--buffer" style={{ width: bufferProgress + '%' }} />
                <div
                    className="vp-progress__range--current vp-progress__range--currentBackground"
                    style={{ width: currentProgress + '%' }}
                />
                {chapters.map((chapter, index) => (
                    <div
                        key={index}
                        className={cn(
                            'vp-progress__range--chapter',
                            chapter.result !== 'PASS' ? 'vp-progress__range--chapterError' : '',
                        )}
                        style={{
                            left: (chapter.time / 1000 / videoDuration) * 100 + '%',
                        }}
                    />
                ))}
                <div className="vp-progress__range--current" style={{ width: currentProgress + '%' }}>
                    <div className="vp-progress__range--current__thumb" />
                </div>
                <input
                    className="vp-progress__range--seek"
                    type="range"
                    step="any"
                    max={videoDuration}
                    value={seekProgress}
                    onMouseMove={onHover}
                    onChange={onSeek}
                />
            </div>

            <span className="vp-progress__tooltip" style={{ left: seekTooltipPosition }}>
                {seekTooltip}
            </span>
        </div>
    );
};

export default memo(Progress);
